import { CaseReducer, createSlice } from '@reduxjs/toolkit';

import { ErrorCode } from 'shared/constants';

export type ErrorState =
  | {
      errorCode: ErrorCode;
      httpStatus: number;
    }
  | {
      errorCode: null;
      httpStatus: null;
    };

const errorsSlice = createSlice<
  ErrorState,
  {
    setError: CaseReducer<ErrorState, { type: string; payload: ErrorState }>;
    clearError: CaseReducer<ErrorState, { type: string }>;
  }
>({
  name: 'errors',
  initialState: {
    errorCode: null,
    httpStatus: null,
  },
  reducers: {
    setError: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    clearError: () => ({
      errorCode: null,
      httpStatus: null,
    }),
  },
});

export const { setError, clearError } = errorsSlice.actions;

export default errorsSlice.reducer;
